import React from "react";
import { IconStar } from "src/icons/StarIcon";
import styles from "./styles.module.scss";

import Tooltip from "@components/tooltip";
import InfoIcon from "@components/infoIcon";
type RatingProps = {
    value: number;
    max?: number;
};

const Rating = ({ value, max = 5 }: RatingProps) => {
    const percentage = Math.round((value / max) * 100);

    return (
        <div className="flex gap-1 items-center ">
            <div className={styles.container}>
                {/* Create an array based on the max rating, render a star for each */}
                {Array.from(Array(max).keys()).map((_, i) => (
                    <IconStar key={String(i)} className={styles.star} />
                ))}
                {/* Render a div overlayed on top of the stars that are not filled */}
                <div
                    className={styles.overlay}
                    style={{ width: `${100 - percentage}%` }}
                />
            </div>
            <Tooltip tooltipMessageKey="several_ratingTooltipMessage">
                <a
                    href="/what-we-do#ratingSystem"
                    style={{ textDecoration: "none" }}
                >
                    <InfoIcon />
                </a>
            </Tooltip>
        </div>
    );
};

export default Rating;
